module.exports = __webpack_public_path__ + "media/images/new-48-white-f610599adcfc2c652954656f6e2a67a0.png";